document.addEventListener("DOMContentLoaded", () => {
  // Lazy Video Loading
  const lazyLoadVideos = () => {
    const lazyVideos = Array.from(document.querySelectorAll("video.lazy"));
    
    if (!('IntersectionObserver' in window)) return;

    const lazyVideoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const video = entry.target;
        video.poster = video.dataset.poster;
        
        Array.from(video.children)
          .filter(source => source.tagName === "SOURCE")
          .forEach(source => source.src = source.dataset.src);

        video.load();
        video.classList.remove("lazy");
        lazyVideoObserver.unobserve(video);
      });
    });

    lazyVideos.forEach(video => lazyVideoObserver.observe(video));
  };

  // Header Height Management
  const setHeaderHeight = () => {
    const header = document.querySelector('.section-header');
    const headerAnnouncement = document.querySelector('.announcement-bar-section');
    const headerReviewBar = document.querySelector('.rating-home');

    if (!header) return;

    let headerHeight = header.offsetHeight;

    document.documentElement.style.setProperty('--sticky-header-height', `${headerHeight}px`);
    
    if (headerAnnouncement) {
      headerHeight += headerAnnouncement.offsetHeight;
    }
    if (headerReviewBar) {
      headerHeight += headerReviewBar.offsetHeight;
    }

    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  };

  // Throttle utility
  const throttle = (func, limit) => {
    let timeoutId;
    let lastRun = 0;
    
    return function (...args) {
      if (!lastRun) {
        func.apply(this, args);
        lastRun = Date.now();
      } else {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          if ((Date.now() - lastRun) >= limit) {
            func.apply(this, args);
            lastRun = Date.now();
          }
        }, limit - (Date.now() - lastRun));
      }
    };
  };

  // Initialize features
  const init = () => {
    lazyLoadVideos();
    setHeaderHeight();
    window.addEventListener('resize', throttle(setHeaderHeight, 200));
  };

  // Ensure proper initialization
  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
});